import { MarkdownToolbars } from '@efdigital/ll-addon-codemirror';

export const SidebarAll = {
  ...MarkdownToolbars.All,
  view: false,
};

export const SidebarSimple = {
  textSize: {
    headings: false,
    display: false,
    fontSize: false,
  },
  textAlign: false,
  lists: true,
  colors: true,
  insert: {
    icons: true,
    links: false,
    images: true,
    cards: false,
    columns: true,
  },
  view: false,
  history: true,
};
